import { EventType } from '@waitroom/analytics';
import { useLogout as useLogoutHook } from '@waitroom/auth';
import { analyticsService } from '../../../../analytics/services';

export type LogoutCallback = () => void;
export const useLogout = (onClick?: LogoutCallback) => {
  const mutation = useLogoutHook({
    onMutate: () => {
      if (onClick) onClick();
      analyticsService.track(EventType.Logout, {}).then(() => {
        analyticsService.logout();
      });
    },
  });
  return mutation;
};
